import { Component } from "react";
import { withRouting } from "@/components/shared/withRouting";
import Footer from "../shared/Footer";
import Loader from "../shared/Loader";
import Alert from "../shared/Alert";

import { Button } from "../shared/Button";

class AccountUnlock extends Component {
  componentDidMount() {
    const unlockAccountParams = new URLSearchParams(this.props.location.search);
    const tokenParam = unlockAccountParams.get("t");
    this.props.unlockAccount({ unlock_token: tokenParam });
  }

  render() {
    return (
      <div className="h-full w-full flex flex-col flex-1 min-h-0 justify-center items-center overflow-y-auto">
        <div className="flex flex-auto w-full">
          {this.props.accountUnlockedStep === "success" ? (
            <div className="flex-auto w-full flex flex-col justify-center items-center">
              <p className="font-['Montserrat',sans-serif] font-bold text-hex-2e96c2 text-[30px] max-lg:mt-[70px] text-center leading-[1.4]">
                Account has been unlocked
              </p>
              <div className="flex justify-center mt-5">
                <div className="FormButton-wrapper flex">
                  <Button
                    kind="primary-purple"
                    className="flex-none mt-2.5 mb-5 w-full !text-lg"
                    onClick={() => this.props.navigate("/login")}
                  >
                    Go to login
                  </Button>
                </div>
              </div>
            </div>
          ) : this.props.err ? (
            <div className="flex flex-col flex-1 w-full min-h-full items-center justify-center">
              <Alert
                variant="error"
                className="inline-block text-center max-w-[250px]"
              >
                {this.props.errMessage}
              </Alert>
            </div>
          ) : (
            <div className="flex flex-col flex-1 w-full min-h-full items-center justify-center">
              <Loader size="80" />
            </div>
          )}
        </div>
        <div className="absolute bottom-[10px] right-[10px] !text-gray-200 max-lg:mx-auto max-lg:pt-[10px] max-lg:static max-lg:w-full max-lg:text-center max-lg:min-h-[100px]">
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouting(AccountUnlock);
